import authFetch from './fetch';
import qs from 'qs';
import { getQueryParams, makeRequest } from './utils';
import { CacheConfig } from './consts';
import { useQuery } from '@tanstack/react-query';
import { EQ_CATEGORY_CHASSIS } from 'src/shared/constants/enums';

const EQUIPMENT_TYPES_PATH = '/api/EquipmentType';

export const routes = {
  equipmentListExcelExportPath: (params) => `/api/EquipmentType/EquipmentList/Export${getQueryParams(params)}`,
  equipmentConditionsPath: () => '/api/EquipmentType/Conditions',
  equipmentStatusPath: (equipmentId, statusId) => `/api/EquipmentType/EquipmentList/${equipmentId}/status/${statusId}`,

  equipmentAuditPath: (equipmentId, params) => `/api/EquipmentType/EquipmentList/${equipmentId}/Audits${getQueryParams(params)}`,
  equipmentAuditPropertiesPath: (equipmentId) => `/api/EquipmentType/EquipmentList/${equipmentId}/Audits/Properties`,
  equipmentAuditUsersPath: (equipmentId) => `/api/EquipmentType/EquipmentList/${equipmentId}/Audits/Users`,

  equipmentTypeAuditPath: (equipmentId, params) => `/api/EquipmentType/Form/${equipmentId}/Audits${getQueryParams(params)}`,
  equipmentTypeAuditPropertiesPath: (equipmentId) => `/api/EquipmentType/Form/${equipmentId}/Audits/Properties`,
  equipmentTypeAuditUsersPath: (equipmentId) => `/api/EquipmentType/Form/${equipmentId}/Audits/Users`,

  // Files
  equipmentFilesPathByEquipmentItemId: (id) => `/api/EquipmentType/EquipmentList/${id}/Files`,
  equipmentFilePath: (id, fileId) => `/api/EquipmentType/EquipmentList/${id}/Files/${fileId}`,
  equipmentFileTypesPath: () => '/api/EquipmentType/FileTypes',
};

export const getEquipmentTypesUrl = (params) => `${EQUIPMENT_TYPES_PATH}/lookup${getQueryParams(params)}`;

export const getEquipmentTypes = async (params = {}) => makeRequest(authFetch.get(getEquipmentTypesUrl(params))).then((data) => data.map((x) => ({ ...x, label: x.name, value: x.id })));

export const useGetEquipmentTypes = (params, opts = {}) => useQuery(['equipmentTypes', getQueryParams(params)], () => getEquipmentTypes(params), { ...CacheConfig.forever, ...opts });
export const useGetChassisTypes = (params = {}, opts = {}) => useGetEquipmentTypes({ ...params, category: EQ_CATEGORY_CHASSIS }, opts);

export const getEquipmentTypesLookup = (params) => makeRequest(
  authFetch.get(`${EQUIPMENT_TYPES_PATH}/lookup${getQueryParams(params)}`),
);

export const getEquipmentType = async (id) => makeRequest(authFetch.get(`/api/EquipmentType/${id}`));

export const deleteEquipmentType = async (id) => makeRequest(authFetch.delete(`/api/EquipmentType/${id}`));

export const restoreEquipmentType = async (id) => makeRequest(authFetch.patch(`/api/EquipmentType/${id}/restore`));

export const getEquipmentTypesPaginated = async (params = {}) => {
  const query = params && Object.keys(params).length > 0 ? `?${qs.stringify(params, { indices: false })}` : '';
  return makeRequest(authFetch.get(`/api/EquipmentType/Grid${query}`));
};

export const getEquipmentCategoryTypes = () => makeRequest(authFetch.get('/api/EquipmentType/Categories'));
export const getEquipmentSubCategoryTypes = (categoryId = null) => makeRequest(authFetch.get(`/api/EquipmentType/SubCategories${categoryId ? `?category=${categoryId}` : ''}`));

export const postEquipmentType = (data) => makeRequest(authFetch.post('/api/EquipmentType', data));

export const getEquipmentSizes = () => makeRequest(authFetch.get('/api/EquipmentType/EquipmentSizes'));

export const getGwiEquipments = (params) => makeRequest(authFetch.get(`/api/EquipmentType/EquipmentList/Grid${getQueryParams(params)}`));

export const getGwiEquipmentsForExport = (params) => makeRequest(authFetch.get(routes.equipmentListExcelExportPath(params)));

export const getGwiEquipment = (id) => makeRequest(authFetch.get(`/api/EquipmentType/EquipmentList/${id}`));

export const postGwiEquipment = (data) => makeRequest(authFetch.post('/api/EquipmentType/EquipmentList', data));

export const deleteGwiEquipment = (id) => makeRequest(authFetch.delete(`/api/EquipmentType/EquipmentList/${id}`));

export const getEquipmentStatusesGrid = (id) => makeRequest(authFetch.get(`/api/EquipmentType/EquipmentList/${id}/status`));

export const getEquipmentStatus = (equipmentId, statusId) => makeRequest(authFetch.get(routes.equipmentStatusPath(equipmentId, statusId)));

export const deleteEquipmentStatus = (equipmentId, statusId) => makeRequest(authFetch.delete(routes.equipmentStatusPath(equipmentId, statusId)));

export const updateEquipmentStatus = (equipmentId, values) => makeRequest(authFetch.patch(`/api/EquipmentType/EquipmentList/${equipmentId}/status`, values));

export const getRepairReasons = () => makeRequest(authFetch.get('/api/EquipmentType/RepairReasons'));

export const getRepairStatuses = () => makeRequest(authFetch.get('/api/EquipmentType/RepairStatus'));

export const getEquipmentConditions = () => makeRequest(authFetch.get(routes.equipmentConditionsPath()));

export const getEquipmentAudit = (id, params) => makeRequest(authFetch.get(routes.equipmentAuditPath(id, params)));

export const getEquipmentAuditProperties = (id) => makeRequest(authFetch.get(routes.equipmentAuditPropertiesPath(id)));

export const getEquipmentAuditUsers = (id) => makeRequest(authFetch.get(routes.equipmentAuditUsersPath(id)));

//
export const getEquipmentTypeAudit = (id, params) => makeRequest(authFetch.get(routes.equipmentTypeAuditPath(id, params)));

export const getEquipmentTypeAuditProperties = (id) => makeRequest(authFetch.get(routes.equipmentTypeAuditPropertiesPath(id)));

export const getEquipmentTypeAuditUsers = (id) => makeRequest(authFetch.get(routes.equipmentTypeAuditUsersPath(id)));
//

export const getEquipmentItemFiles = (id, params) => makeRequest(authFetch.get(`${routes.equipmentFilesPathByEquipmentItemId(id)}${getQueryParams(params)}`));

export const postEquipmentItemFiles = (id, files) => makeRequest(authFetch.post(routes.equipmentFilesPathByEquipmentItemId(id), files));

export const deleteEquipmentItemFile = (id, fileId) => makeRequest(authFetch.delete(routes.equipmentFilePath(id, fileId)));

export const putEquipmentItemFile = (id, fileId, file) => makeRequest(authFetch.put(routes.equipmentFilePath(id, fileId), file));

export const getEquipmentItemFileTypes = () => makeRequest(authFetch.get(routes.equipmentFileTypesPath()));
